import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "display"];

  select(e) {
    this.displayTarget.innerHTML =
      e.currentTarget.dataset.display || e.currentTarget.innerText;
    this.inputTarget.value = e.currentTarget.dataset.value;
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
